import {
  ApartmentOutlined,
  CloseOutlined,
  DeleteOutlined,
  TeamOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import { Button, Modal } from "antd";
import { FC } from "react";
import "./index.css";

interface DeleteDepartmentModalProps {
  open: boolean;
  departmentName: string;
  memberCount: number;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}

const DeleteDepartmentModal: FC<DeleteDepartmentModalProps> = ({
  open,
  departmentName,
  memberCount,
  loading,
  onCancel,
  onConfirm,
}) => (
  <Modal
    maskClosable={false}
    keyboard={false}
    centered
    className="deleteDepartmentModal"
    closable={false}
    destroyOnClose
    footer={null}
    onCancel={onCancel}
    open={open}
    title={null}
    width={500}
  >
    <div className="deleteDepartmentModal__shell">
      <header className="deleteDepartmentModal__header">
        <div className="deleteDepartmentModal__dangerIcon">
          <DeleteOutlined />
        </div>
        <div className="deleteDepartmentModal__heading">
          <span>危险操作</span>
          <h2>删除部门</h2>
        </div>
        <Button
          aria-label="关闭删除部门弹窗"
          className="deleteDepartmentModal__close"
          disabled={loading}
          icon={<CloseOutlined />}
          onClick={onCancel}
          title="关闭"
        />
      </header>

      <div className="deleteDepartmentModal__body">
        <section className="deleteDepartmentModal__department">
          <div className="deleteDepartmentModal__departmentIcon">
            <ApartmentOutlined />
          </div>
          <div>
            <span>即将删除</span>
            <strong>{departmentName}</strong>
          </div>
        </section>

        <section className="deleteDepartmentModal__impact">
          <div className="deleteDepartmentModal__impactTitle">
            <WarningOutlined />
            <strong>删除影响</strong>
          </div>
          <p>部门会从所有关联成员的资料中移除，但不会删除成员账号</p>
          <div className="deleteDepartmentModal__memberCount">
            <TeamOutlined />
            <span>{memberCount > 0 ? `${memberCount} 名成员` : "暂无关联成员"}</span>
          </div>
        </section>
      </div>

      <footer className="deleteDepartmentModal__footer">
        <Button
          aria-label="取消删除部门"
          className="deleteDepartmentModal__cancel"
          disabled={loading}
          onClick={onCancel}
        >
          取消
        </Button>
        <Button
          aria-label="确认删除部门"
          className="deleteDepartmentModal__confirm"
          disabled={loading}
          icon={<DeleteOutlined />}
          loading={loading}
          onClick={onConfirm}
        >
          确认删除
        </Button>
      </footer>
    </div>
  </Modal>
);

export default DeleteDepartmentModal;
